import Vue from 'vue'
import dialog from './dialog/dialog'
import FontIcon from './font-icon'
import qDialog from './qDialog/qDialog'
import remark from './remark/remark'
import textCollapse from './text-collapse/text-collapse'
import SearchBox from './search-box/search-box'
import TablePanel from './TablePanel/table-panel'
import ContentPanel from './content-panel/content-panel'
import QTableColumn from './qTable/qTableColumn/q-table-column.vue'
import QTableHeaderFilter from './qTableHeaderFilter/q-table-header-filter.vue'
import CustomTable from './customTable/customTable.vue'
import KVPanel from './k-v-panel/k-v-panel'
import ScrollPanel from './horizontal-scroll-panel/scroll-panel'
import TextTip from './text-with-tooltip/text-with-tooltip'
import RemoteSearchSelect from './remote-search-select/remote-search-select'
import FormDateRange from './form-date-range/form-date-range.vue'
import FormMonthRange from './form-month-range/form-month-range.vue'
// import SvgIcon from './svg-icon/svg-icon'
// import {render as renderSVG} from './svg-icon/render-svg'
// renderSVG();

const components = [
  dialog, FontIcon, qDialog, remark, textCollapse, SearchBox, TablePanel, 
  ContentPanel, QTableColumn, QTableHeaderFilter, KVPanel, ScrollPanel, 
  TextTip, CustomTable, RemoteSearchSelect, FormDateRange, FormMonthRange
];
components.forEach(component => {
  Vue.component(component.name, component);
});